var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('app-header',{attrs:{"user":_vm.user}}),_vm._v(" "),_c('me-navigation-error',{attrs:{"title":"Não encontramos a página","description":"Por favor, tente novamente ou volte para o início.","image":{
      url: '/images/ilustrations/404.svg',
      alt: 'Ilustração de uma porta aberta levando para um quarto escuro com uma caixa vazia abandonada',
    }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }